module.exports = __webpack_public_path__ + "img/referral.fb98043d.png";